import {useContext, useEffect, useState} from 'react';
import ApiList from '../assets/ApiList';
import LinkFile from '../LinkFile';
import { updateMessage, updateMmsFile, updateShowQuickReply } from '../reducers/Action';
import { SmsSendContext } from '../reducers/GlobalReduers';
import QuickReplySkeleton from '../../Email/pages/QuickReplySkeleton';
import { PRIVACY_LEVEL } from '../../../../helpers/CoreConstant';
import GlobalPrivacyTab from '../../globalPrivacyTab';
import EmptyStateMessageWithPicture from '../../../GlobalContactDetailsForDeal/LeftSide/common/EmptyStateMessageWithPicture';

const QuickRepliesForSms = (props) => {
    const {dispatch} = useContext(SmsSendContext)
    const [isLoading, setIsLoading] = useState(true)
    const [templates, setTemplates] = useState([])

    /* for fetching data onscroll */
    const [perPage, setPerPage] = useState(20)
    const [currentPage, setCurrentPage] = useState(0)

    const [activeTab, setActiveTab] = useState(PRIVACY_LEVEL.PRIVACY_LEVEL_GLOBAL);

    useEffect(() => {
        if(props.scrolling){
            ApiList.getSmsTemplates({
                search_key: "",
                type: [2,5],
                'perPage': perPage,
                'page': currentPage + 1,
                privacy_level: activeTab
            }).then(res => {
                let response = res.data
                if(response.status === 'success'){
                    setCurrentPage(currentPage + 1);
                    if(response.html.length >= perPage){
                        if(props.updateScrollOption !== undefined){
                            props.updateScrollOption("needToLoad", true);
                        }
                
                    }
                    else{
                        if(props.updateScrollOption !== undefined){
                            props.updateScrollOption("needToLoad", false)
                        }
                    }
                    if(props.updateScrollOption !== undefined){
                        props.updateScrollOption("fetchingMore", false)
                    }
                    setTemplates([...templates, ...response.html])
                }
            })
        }
    }, [props.scrolling]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        ApiList.getSmsTemplates({
            search_key: "",
            type: [2,5],
            'perPage': perPage,
            'page': 0,
            privacy_level: activeTab
        }).then(res => {
            let response = res.data
            if(response.status === 'success'){
                setCurrentPage(0);
                setTemplates(response.html)

                if(response.html.length >= perPage){
                    if(props.updateScrollOption !== undefined){
                        props.updateScrollOption("needToLoad", true)
                    }
                }
                else{
                    if(props.updateScrollOption !== undefined){
                        props.updateScrollOption("needToLoad", false)
                    }
                }
                if(props.updateScrollOption !== undefined){
                    props.updateScrollOption("fetchingMore", false)
                }
            }
            setIsLoading(false)
        })
        return () => setIsLoading(true)
    }, [activeTab]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleBackButton = () => {
        dispatch(updateShowQuickReply(false))
    }

    const hanldeTemplateChange = (item) => {
        if(item.type == 5){
            dispatch(updateMmsFile({
                file_url: item.video_file_url,
                file_data: null,
                selectedMmsFromTemplate: true
            }));
            dispatch(updateMessage({
                message: item.message,
                message_type: 5
            }));
        }
        else{
            dispatch(updateMmsFile({
                file_url: '',
                file_data: null,
                selectedMmsFromTemplate: false
            }));
            dispatch(updateMessage({
                message: item.message,
                message_type: 2
            }));
        }
        handleBackButton()
    }

    const renderList = () => {
        let list = []
        templates.forEach((item, index) => {
            list.push(<LinkFile.QucikReplyCard
                data={item}
                key={index}
                onSelect={hanldeTemplateChange}
            />)
        });
        return list;
    }

    const handleActiveTab = (_event, newValue) => {
        setActiveTab(newValue);
    };

    return(
        <div className="g-email-template-content">
            <div className="g-template-header">
                <span className="g-template-title">Quick Reply List</span>
                <div className="g-template-back" > 
                    <div onClick={handleBackButton} className="quick__back__btn__alt accent--bg--color accent--bg--text--color">{'<<'} Back</div>
                </div>
            </div>

            <GlobalPrivacyTab activeTab={activeTab} handleTabChange={handleActiveTab} />

            <div className="g-template-body awesome__scroll_bar">
                {isLoading ? 
                    <QuickReplySkeleton/>
                 :
                    renderList()
                }
            </div>

            {
                !isLoading && templates.length === 0 && (<EmptyStateMessageWithPicture />)
            }
        </div>
    )
}
export default QuickRepliesForSms;


